import { SxProps } from '@mui/material'
import { popperDimensions } from '@/components/Surface/Popper/Popper.data'
import { dropdownListClasses } from './DropdownList.data'

interface DropdownListStyles {
  list: SxProps
  listItem: SxProps
  listItemButton: SxProps
  listItemText: SxProps
}

export const dropdownListStyles: DropdownListStyles = {
  list: {
    p: 0,
    width: `calc(100% + ${popperDimensions.paddingInPx * 2}px)`, // 2 * one side padding (left and right)
    ml: `-${popperDimensions.paddingInPx}px`, // negative margin to offset the padding
    maxHeight: { xs: 250, md: 300 },
    overflowY: 'auto',
  },
  listItem: {
    p: 0,
  },
  listItemButton: {
    px: 1.5,
  },
  listItemText: {
    color: 'text.primary900',
    typography: 'textMd',

    [`.${dropdownListClasses.selectedItem} &`]: {
      color: 'brand.primary600',
    },
  },
}
